<template>
  <div class="Assessment login">
    <TopNavBar navtitle="考官评审"></TopNavBar>
    <div class="areabatchinfo" v-if="IsOnline == 0" @click="scanQRCode">
      <h1>
        点击扫码，进行线下评审
      </h1>
    </div>
    <div class="areabatchinfo" v-else>
      <h1>
        进入考场
      </h1>
    </div>
    <div class="Assessbox">
      <div class="areabatch">
        <ul>
          <li>
            <h2>选择批次</h2>
            <div class="bitem">
              <span
                v-for="(item, index) in ExamBatchList"
                :key="index"
                :name="item.EB_ID"
                :class="quertList.EB_ID == item.EB_ID ? 'radiochecked' : ''"
                @click="onCheckedbatch(item)"
                >{{ item.EB_Name }}</span
              >
            </div>
          </li>
          <li v-if="Majors.length > 0">
            <h2>选择专业</h2>
            <div class="aitem">
              <span
                v-for="(item, index) in Majors"
                :key="index"
                :name="item.MID"
                :class="MID == item.MID ? 'radiochecked' : ''"
                @click="onCheckedMID(item)"
                >{{ item.MName }}</span
              >
            </div>
          </li>
          <li v-if="MID != 0">
            <h2>选择考场</h2>
            <div class="aitem">
              <span
                v-for="(item, index) in ExamTimeList.filter(s => s.MID == MID)"
                :key="index"
                :name="item.ET_ID"
                @click="SelectExamTime(item)"
                >{{ item.ExamRoom }}</span
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import TopNavBar from "@/components/TopNavBar.vue";
import { GetALLExamBatchMenuList } from "@/api/exam";
import { GetExamTimeMajors } from "@/api/examiner";
import wx from "weixin-js-sdk";
const defaultQueryList = {
  PageSize: 20,
  PageIndex: 1,
  EB_ID: null,
  OrderBy: null
};
export default {
  components: {
    TopNavBar
  },
  data() {
    return {
      ExamBatchList: null,
      quertList: Object.assign({}, defaultQueryList),
      show: false,
      ExamTimeList: [],
      total: 0, //总共的数据条数
      loading: false,
      finished: false,
      Majors: [],
      MID: 0,
      IsOnline: 1
    };
  },
  created() {
    this.IsOnline = this.$route.query.IsOnline ?? 0;
    this.GetInitList();
  },
  methods: {
    GetExamTimeMajors(EB_ID) {
      GetExamTimeMajors({ EB_ID: EB_ID, IsOnline: this.IsOnline }).then(res => {
        this.ExamTimeList = res.listData;
        this.ExamTimeList.forEach(item => {
          if (item.MID != 0) {
            if (
              !this.Majors ||
              this.Majors.filter(s => s.MID == item.MID).length == 0
            ) {
              this.Majors.push(item.Majors);
            }
          }
        });
      });
    },
    async GetInitList() {
      //获取所有考试批次信息
      await GetALLExamBatchMenuList().then(res => {
        this.ExamBatchList = res.listData;
      });
    },
    onCheckedbatch(ExamBatch) {
      if (this.quertList.EB_ID == ExamBatch.EB_ID) {
        this.quertList.EB_ID = null;
        this.Majors = [];
        this.ExamTimeList = null;
        this.MID = 0;
      } else {
        this.quertList.EB_ID = ExamBatch.EB_ID;
        this.GetExamTimeMajors(this.quertList.EB_ID);
      }
    },
    onCheckedMID(Majors) {
      if (this.MID == Majors.MID) {
        this.MID = 0;
      } else {
        this.MID = Majors.MID;
      }
      console.log("this.MID :>> ", this.MID);
    },
    SelectExamTime(ExamTimeInfo) {
      if (this.IsOnline == 0) {
        this.$router.push({
          path: `/OnSiteReview?ExamRoom=${ExamTimeInfo.ExamRoom}&EB_ID=${this.quertList.EB_ID}`
        });
      } else {
        this.$router.push({
          path: `/ExamTimeUserList?ExamRoom=${ExamTimeInfo.ExamRoom}&EB_ID=${this.quertList.EB_ID}`
        });
      }
    },

    scanQRCode() {
      if (this.IsOnline == 0)
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function(res) {
            location.href = "/ReviewInfo?param=" + res.resultStr;
          }
        });
    }
  }
};
</script>

<style>
.Assessment {
  background: url(../assets/kgkp.jpg) #04080f top no-repeat;
  min-height: 80vh;
  width: 100%;
}
.Assessbox {
  background: #fff;
  border-radius: 15px 15px 0 0;
  width: 100%;
  margin: 5vh auto 0;
  padding: 10px;
  box-sizing: border-box;
}
.Assessbox .enrolllist {
  width: 100%;
}
.Assessbox .van-tabs .van-hairline--top-bottom::after,
.Assessbox .van-tabs .van-hairline-unset--top-bottom::after {
  border: 0;
}

.Assessbox .enrolllist .van-list .examinfo img {
  position: absolute;
  left: 1%;
  border-radius: 5px;
}
.Assessbox .enrolllist .van-list .examinfo li {
  margin-left: 23vw;
}
.enrolllist ul li.spaceBetween {
  justify-content: flex-start;
}
.enrolllist ul li.spaceBetween button {
  margin-right: 3%;
  width: 47%;
}
.enrolllist .van-list .van-cell {
  padding: 0;
}
.enrolllist .van-list .van-cell::after {
  border-bottom: 0;
}
.areabatchinfo h1 {
  width: 90%;
  border-radius: 30px;
  margin: 10px auto;
  padding: 10px 0;
}
.areabatchinfo h1 b {
  margin-right: 15px;
}
.areabatchinfo p {
  color: #fff;
  font-size: 3vw;
}
.areabatchinfo p span {
  margin: 0 3px;
}
.areabatch .next {
  margin: 35px auto;
  padding: 25px 0;
  background: linear-gradient(to left, #fb905b, #ef2158);
  border: 0;
}
.areabatch ul li h2 {
  text-align: left;
  color: #555;
  font-weight: 500;
  padding: 20px 0 5px;
}
.areabatch ul li .aitem,
.areabatch ul li .bitem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.areabatch ul li .aitem span,
.areabatch ul li .bitem span {
  background: #e1e1e1;
  border-radius: 5px;
  padding: 15px 10px;
  margin: 1% 1% 2% 0;
  color: #333;
  font-size: 3.2vw;
}
.areabatch ul li .aitem span.radiochecked,
.areabatch ul li .bitem span.radiochecked {
  background: linear-gradient(to right, #fb8c5b, #f02658);
  color: #fff;
}
.areabatch ul li .aitem span {
  width: 26%;
}
.areabatch ul li .bitem span {
  width: 100%;
  display: flex;
  align-items: center;
  display: inline-block;
  text-align: center;
  padding: 15px 0;
}
</style>
